import { handleDispatchResult } from '@wajeez-web/core/utils';
import { store } from '@wajeez-web/stores/base';
import { Server } from '@wajeez-web/core/api-base';
import {
  createVoiceActorAsync,
  editVoiceActorAsync,
  getVoiceActorByIdAsync,
  getVoiceActorByIdMultilingualAsync,
  getVoiceActorsLookupsAsync,
  setContentEntityVoiceActorAsync,
} from './slices';
import { VoiceActorsActions } from '.';

export const getVoiceActorsLookups = async (
  searchString?: string,
  onSuccess?: (res: Server.VoiceActorResponse[]) => void | Promise<void>
) => {
  const res = await store.dispatch(getVoiceActorsLookupsAsync(searchString));

  return handleDispatchResult(res, onSuccess);
};

export const getVoiceActorById = async (
  id: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getVoiceActorByIdAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const createVoiceActor = async (
  body: Server.CreateVoiceActorCommand,
  onSuccess?: (res: string) => void | Promise<void>
) => {
  const res = await store.dispatch(createVoiceActorAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const editVoiceActor = async (
  body: Server.EditVoiceActorCommand,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(editVoiceActorAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const getVoiceActorByIdMultilingual = async (
  id: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getVoiceActorByIdMultilingualAsync(id));
  return handleDispatchResult(res, onSuccess);
};

export const clearVoiceActorById = async () => {
  store.dispatch(VoiceActorsActions.clearVoiceActorById());
};

export const clearVoiceActorByIdMultilingual = async () => {
  store.dispatch(VoiceActorsActions.clearByIdMultilingual());
};

export const setContentEntityVoiceActor = async (
  input: Server.SetContentEntityVoiceActorCommand,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(setContentEntityVoiceActorAsync(input));
  return handleDispatchResult(res, onSuccess);
};
